import { CardActions, CardContent, DialogContent, Link, Typography } from "@mui/material";
import { CloseDialogButton, DialogContentWrapper } from "apps/wrapper/src/components/shared/dialog/dialog.styles";
import { usePatientProfile } from "apps/wrapper/src/hooks/use-patient-profile";
import { CareCreditPatientPrescreenInfo } from "apps/wrapper/src/types/payment/care-credit";
import { formatDate } from "apps/wrapper/src/utils/date-time";
import { formatDollarAmount } from "apps/wrapper/src/components/layout/slideout/patient-profile-widget/utils/format-dollar-amount";
import { PrimaryButton, SecondaryButton } from "apps/wrapper/src/components/shared/buttons";
import { useState } from "react";
import { Card } from "../../../../patient-profile-page.styles";
import { CopyToClipboardButton } from './copy-to-clipboard-button';
import {
  BodyTitle,
  CareCreditLogo,
  Column,
  Dialog,
  DialogTitle,
  Row,
  PatientLinkComponent,
  PatientLinkWrapper
} from './carecredit.styles';
import { PresentOfferModal } from "./present-offer-modal";

type CareCreditPreApprovalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  careCreditInfo: CareCreditPatientPrescreenInfo;
};

const formatMerchantNumber = (number: string) => {
  if (!number) return '';

  const maskedPart = `***********${  number.substring(11)}`;
  const formattedNumber = maskedPart.replace(/\s/g, '');

  return formattedNumber;
};


export const CareCreditPreApprovalModal = ({ isOpen, onClose, careCreditInfo }: CareCreditPreApprovalModalProps) => {
  const { contactDetails } = usePatientProfile();
  const [showOfferDialog, setShowOfferDialog] = useState(false);
  const patientName = `${contactDetails.firstName} ${contactDetails.lastName}`;

  return (
    <>
      <Dialog open={isOpen}>
        <DialogContentWrapper>
          <DialogTitle>
            {contactDetails.firstName} {contactDetails.lastName} - Pre-Approval
            <CloseDialogButton onClick={onClose} />
          </DialogTitle>
          <DialogContent>
            <Card>
              <CardContent>
                <CareCreditLogo />
                <Row>
                  <Column>
                    <div>
                      <BodyTitle>Date</BodyTitle>
                      <Typography>{formatDate(careCreditInfo.date)}</Typography>
                    </div>
                    <div>
                      <BodyTitle>Credit Limit</BodyTitle>
                      <Typography>{formatDollarAmount(careCreditInfo.preApprovedAmount)}</Typography>
                    </div>
                  </Column>
                  <Column>
                    <div>
                      <BodyTitle>Pre-Approval Auth #</BodyTitle>
                      <Typography>{careCreditInfo.authorizationNumber}</Typography>
                    </div>
                    <div>
                      <BodyTitle>Merchant Number</BodyTitle>
                      <Typography>{formatMerchantNumber(careCreditInfo.merchantNumber)}</Typography>
                    </div>
                  </Column>
                  <Column>
                    <div>
                      <BodyTitle>Applicant Name</BodyTitle>
                      <Typography>{patientName}</Typography>
                    </div>
                  </Column>
                </Row>
                <PatientLinkComponent>
                  <PatientLinkWrapper>
                    <Typography>Patient Link: &nbsp;</Typography>
                    <Link target="_blank" rel="noopener noreferrer" href={careCreditInfo.careCreditLink}>
                      {careCreditInfo.careCreditLink}
                    </Link>
                    <CopyToClipboardButton textToCopy={careCreditInfo.careCreditLink} />
                  </PatientLinkWrapper>
                  <Typography sx={{ fontSize: '10px' }}>
                    Share this link with the patient so they can review and submit a CareCredit application on their own
                    device.
                  </Typography>
                </PatientLinkComponent>
                <CardActions>
                  <SecondaryButton
                    onClick={onClose}
                    color="primary"
                    variant="outlined"
                    disableElevation
                    sx={{ marginRight: '10px' }}
                  >
                    CLOSE
                  </SecondaryButton>
                  <PrimaryButton onClick={() => setShowOfferDialog(true)} disableElevation>
                    PRESENT OFFER AND RECORD PATIENT DECISION
                  </PrimaryButton>
                </CardActions>
              </CardContent>
            </Card>
          </DialogContent>
        </DialogContentWrapper>
      </Dialog>
      <PresentOfferModal isOpen={showOfferDialog} onClose={() => setShowOfferDialog(false)} patientId={contactDetails.id} />
    </>
  );
};
